"use strict";

module.exports = ['Acetic Acid', 'Acetone', 'Acetonitrile', 'Dichloromethane', 'Diethyl Ether', 'Dimethylformamide (DMF)', 'Dimethylsulfoxide (DMSO)', 'Ethanol', 'Ethyl Acetate', 'Hexane', 'Methanol', 'Tetrahydrofuran', 'Toluene', 'Water'];